export const tagKeys = [
  'agent',
  'search',
  'image',
  'videos',
  'weather',
  'finance',
  'design',
  'travel',
  'social',
  'news',
  'medical',
  'productivity',
  'education',
  'business',
  'entertainment',
  'utilities',
  'other',
]

export const categoryKeys = [
  'model',
  'tool',
  'agent-strategy',
  'extension',
  'bundle',
]
